import { render, staticRenderFns } from "./ControlRadio.vue?vue&type=template&id=6a4e2a7e&"
import script from "./ControlRadio.vue?vue&type=script&lang=js&"
export * from "./ControlRadio.vue?vue&type=script&lang=js&"
import style0 from "./ControlRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports